export enum PaymentSource {
  Adyen = 'ADYEN',
  Amazon = 'AMAZON',
  Affirm = 'AFFIRM',
  Apple = 'APPLE',
  PayPal = 'PAYPAL'
}
